module.exports = __webpack_public_path__ + "img/danger_type_modif.2e641583.svg";